'use strict';

var router = require('./../../app/router'); // eslint-disable-line

// --------------------- Write after this all the route events ---------------------
// Example:
// router.on('route:home', require('./../../app/client/home/views/home.js'));
// ---------------------------------------------------------------------------------


// created_at: 2017-01-24T21:25:03+00:00
router.on('route:mcp-1000', require('../../app/client/mcp-1000/js/mcp-1000.js'));
router.on('route:mcp-1000/', require('../../app/client/mcp-1000/js/mcp-1000.js'));
router.on('route:mcptest', require('../../app/client/mcp-1000/js/mcp-1000.js'));
router.on('route:mcptest/', require('../../app/client/mcp-1000/js/mcp-1000.js'));
router.on('route:mcp-year', require('../../app/client/mcp/js/mcp.js'));
router.on('route:mcptest-year', require('../../app/client/mcp/js/mcp.js'));
router.on('route:person-index', require('../../app/client/person-index/js/person-index.js'));
router.on('route:person', require('../../app/client/person/js/person.js'));
